import { useState, useEffect, useRef } from 'react';
import { CheckboxField, TextareaField } from '@/components/formParts';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { privacyPolicy} from '@/data';

// バリデーション用のスキーマ設定
const schema = z.object({
  // terms_checked: z.boolean().refine((val) => val !== false, { message: "同意チェックは必須です" }),
  privacy_checked: z.boolean().refine((val) => val !== false, { message: "同意チェックは必須です" }),
});

// バリデーション用の型定義
export type ContactAgreementFormData = z.infer<typeof schema>;


// フォームコンポーネント
const ContactAgreementForm = ({
  enabled,
  onValidationChange,
  shouldSubmit,
  onAgreeChange,              // 追加
}: {
  enabled: boolean;
  onValidationChange: (data: { isValid: boolean; formData: ContactAgreementFormData | undefined }) => void;
  shouldSubmit: boolean;
  onAgreeChange?: (agreed: boolean) => void; // 追加
}) => {

  const { register, watch, formState: { errors, isValid }, trigger } = useForm<ContactAgreementFormData>({
    mode: 'onTouched',
    resolver: zodResolver(schema),
    defaultValues: { privacy_checked: false }, 
  });


  // 親にバリデーション状態を通知
  // useEffect(() => {
  //     onValidationChange({isValid, formData: isValid ? watch() : undefined});
  // }, [isValid]);
    // 現在値も含めて常時通知（チェックONで即伝播）

  // 親からのsubmit要求があったらバリデーションを実行
  useEffect(() => {
    if( shouldSubmit ) {
      trigger();
    }
  }, [shouldSubmit]);

  // スクロール監視用の状態
  // const [termsScrolled, setTermsScrolled] = useState(false);
  const [privacyScrolled, setPrivacyScrolled] = useState(false);

  // const termsRef = useRef<HTMLTextAreaElement>(null);
  const privacyRef = useRef<HTMLTextAreaElement>(null);

  // スクロール監視の設定
  useEffect(() => {
    // const termsElement = termsRef.current;
    const privacyElement = privacyRef.current;

    // const handleTermsScroll = () => {
    //   if (termsElement) {
    //     const { scrollTop, scrollHeight, clientHeight } = termsElement;
    //     const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // 5pxの余裕を持たせる
    //     if (isAtBottom) {
    //       setTermsScrolled(isAtBottom);
    //       termsElement.removeEventListener('scroll', handleTermsScroll);
    //     }
    //   }
    // };

    const handlePrivacyScroll = () => {
      if (privacyElement) {
        const { scrollTop, scrollHeight, clientHeight } = privacyElement;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 5; // 5pxの余裕を持たせる
        if (isAtBottom) {
          setPrivacyScrolled(isAtBottom);
          privacyElement.removeEventListener('scroll', handlePrivacyScroll);
        }
      }
    };

    // if (termsElement) {
    //   termsElement.addEventListener('scroll', handleTermsScroll);
    // }
    if (privacyElement) {
      privacyElement.addEventListener('scroll', handlePrivacyScroll);
    }

  }, []);

  return (
    <>
      {/* <div className="flex flex-col gap-2">
        <TextareaField label="利用規約" value={terms} rows={6} ref={termsRef} readOnly={true} disabled={!enabled} />
        <p className="m-form-note">※全文をお読みいただいたうえで、チェックボックスにチェックしてください。</p>
        <CheckboxField 
          options={[{ label: '利用規約に同意します', value: '' }]} 
          register={register('terms_checked')} 
          errors={errors} 
          hasRequiredLabel={true} 
          disabled={!enabled || !termsScrolled} 
        />
      </div> */}
      <div className="flex flex-col gap-2">
        <TextareaField label="" value={privacyPolicy} rows={6} ref={privacyRef} readOnly={true} disabled={!enabled} hasRequiredLabel={true} />
        {/* <p className="m-form-note">※個人情報の取扱いについて確認、理解した上で同意する</p> */}
        <CheckboxField 
          options={[{ label: '個人情報の取扱いについて確認、理解した上で同意する', value: '' }]} 
            register={register('privacy_checked', {
                 onChange: (e) => {
                   const checked = !!e?.target?.checked;           // ← booleanで受ける
                   onValidationChange({ isValid: checked, formData: { privacy_checked: checked } });
                   onAgreeChange?.(checked);                        // ← 親へ即通知
                 }
               })}
          errors={errors} 
          hasRequiredLabel={true} 
          disabled={!privacyScrolled} 
        />
      </div>
    </>
  );
}

export default ContactAgreementForm;
